// BookDetail through context, so no child of /books/:id fetches it again.
// BookLayout owns the one polling query and provides the payload; a screen
// asks useBookDetail() and gets the same object the nav is rendering.
import type { BookDetail } from "@contract";
import { createContext, useContext } from "react";

export interface BookContextValue {
  readonly book: BookDetail;
  /** True while a refetch is in flight, for a quiet "updating" hint. */
  readonly isFetching: boolean;
}

const BookContext = createContext<BookContextValue | null>(null);

export const BookProvider = BookContext.Provider;

/**
 * The Book of the route. Throws outside BookLayout rather than handing back a
 * null the caller would have to branch on: every screen under /books/:id is a
 * child of that layout, so an undefined here is a wiring mistake.
 */
export function useBookContext(): BookContextValue {
  const value = useContext(BookContext);
  if (!value) throw new Error("useBookContext outside BookLayout");
  return value;
}

export const useBookDetail = (): BookDetail => useBookContext().book;
